import { useState } from 'react'

import { useNotification } from '../../../../../hooks'
import {
  getIsPhotoPersisted,
  getPhotoById,
  getPhotoFileId,
} from '../../RentalPortalPhotoGallery.utils'

export function useRentalPortalPhotoGalleryDelete({
  photos,
  onDeletePhoto,
  onExcludeFile,
  onRemoveUploadTile,
}) {
  const { handleAddErrorNotification } = useNotification()

  const [deletingPhoto, setDeletingPhoto] = useState(null)

  function handleCancelDelete() {
    setDeletingPhoto(null)
  }

  async function handleConfirmDelete() {
    try {
      await onDeletePhoto(getPhotoFileId(deletingPhoto))
    } catch {
      handleAddErrorNotification('RentalPortal.ListingPhotoDeleteErrorKey')

      return
    }

    onExcludeFile(deletingPhoto.id)
    setDeletingPhoto(null)
  }

  function handleDeletePhoto(photoId) {
    const photo = getPhotoById({ photoId, photos })

    if (photo && getIsPhotoPersisted(photo)) {
      if (onDeletePhoto) {
        setDeletingPhoto(photo)
      } else {
        onExcludeFile(photoId)
      }

      return
    }

    onRemoveUploadTile(photoId)
  }

  return {
    deletingPhoto,
    handleCancelDelete,
    handleConfirmDelete,
    handleDeletePhoto,
  }
}
